import { h } from 'preact';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { useCallback } from 'preact/hooks';
import Translate from '../translate/translate';

const GeneralErrorMessage = () => {
	const refreshPage = useCallback(() => {
		// @ts-ignore
		window.location.reload(false);
	}, []);

	return (
		<div className="general-error-message" data-testid="general-error-message">
			<div className="general-error-details">
				<BringgIcon iconName={BringgFontIcons.CircleExclamation} className="general-error-icon" />
				<div className="general-error-title">
					<Translate text="OOPS" />
				</div>
				<div className="general-error-description">
					<Translate text="SOMETHING_WENT_WRONG" />
				</div>
			</div>

			<div className="general-error-refresh-container">
				<button className="general-error-refresh-button" onClick={refreshPage}>
					<Translate text="REFRESH" />
				</button>
			</div>
		</div>
	);
};

export default GeneralErrorMessage;
